import { render, staticRenderFns } from "./IconFiles.vue?vue&type=template&id=28b31ba1&"
import script from "./IconFiles.vue?vue&type=script&lang=js&"
export * from "./IconFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28b31ba1')) {
      api.createRecord('28b31ba1', component.options)
    } else {
      api.reload('28b31ba1', component.options)
    }
    module.hot.accept("./IconFiles.vue?vue&type=template&id=28b31ba1&", function () {
      api.rerender('28b31ba1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconFiles.vue"
export default component.exports